import React, { createContext } from 'react';
import PostulantStore from './postulant-store';

export const Context = createContext({});

export default (props) => {
  const { data, children } = props;
  return (
    <Context.Provider value={new PostulantStore({ drive: data.drive, clientAppDrive: data.clientAppDrive })}>
      {children}
    </Context.Provider>
  );
};
